import { render, staticRenderFns } from "./create.vue?vue&type=template&id=0630c964&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0630c964')) {
      api.createRecord('0630c964', component.options)
    } else {
      api.reload('0630c964', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=0630c964&", function () {
      api.rerender('0630c964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/payment/create.vue"
export default component.exports